/* ========================= quiz.js ========================= */
(function() {
    const modal = document.getElementById('quiz-modal');
    // flag to know if the quiz added any items
    let quizAddedItems = false;
  
    // close when clicking on the overlay (but not when clicking inside the modal content)
    modal.addEventListener('click', e => {
      if (e.target === modal) {
        closeQuiz();
      }
    });
  
    const content = document.getElementById('quiz-content');
    const isLoggedIn = window.isLoggedIn;
  
    const questions = [
      { question: "🧴 Si do ta përshkruaje lëkurën tënde?", answers: ["E yndyrshme","E thatë","E kombinuar","Normale"] },
      { question: "🙋‍♀️ Sa e ndjeshme është lëkura jote?", answers: ["Po, është shumë e ndjeshme","Po, jam pak e ndjeshme","Jo, nuk është e ndjeshme"] },
      { question: "🔍 Çfarë shqetësimesh ke me lëkurën tënde?", answers: ["Pika të zeza ose pore të bllokuara","Pore të zgjeruara","Vija të holla ose rrudha të para","Hiperpigmentim (njolla të errëta, ton jo i barabartë)","Humbje e elasticitetit ose fortësisë së lëkurës"] },
      { question: "💇‍♀️💅 A ke ndonjë problem me flokët ose thonjtë?", answers: ["Flokë të dobët, të brishtë ose thonj që këputen lehtë","Rënie ose rrallim i flokëve","Flokë të thatë dhe pa shkëlqim","Nuk kam ndonjë shqetësim me flokët ose thonjtë"] },
      { question: "🤰 A je aktualisht shtatzënë ose duke ushqyer me gji?", answers: ["Po, jam shtatzënë","Po, jam duke ushqyer me gji","Jo, nuk jam as shtatzënë as gjidhënëse"] }
    ];

    const rosaceaOption = "Skuqje e vazhdueshme / rosacea";
  
    const skinTypeMap = {
      "E yndyrshme": "oily",
      "E thatë":     "dry",
      "E kombinuar": "combination",
      "Normale":     "normal"
    };
  
    // Master serum lists (excluding collagen)
    const rawSerumMap = {
      dry:         ["Vitamin C","Lactic Acid","Hyaluronic Acid"],
      normal:      ["Vitamin C","Hyaluronic Acid","Glycolic Acid","Salicylic Acid"],
      oily:        ["Dual Renewal","Salicylic Acid","Niacinamide","Vitamin C"],
      combination: ["Dual Renewal","Salicylic Acid","Niacinamide","Vitamin C"]
    };
  
    const collagenTitle = "Pure Collagen";
  
    let step = 0;
    let userAnswers = [];
  
    function closeQuiz() {
      // hide the quiz
      modal.style.display = 'none';
      sessionStorage.setItem('quizSeen', 'true');
  
      // if we added anything from the quiz, force a full refresh
      if (quizAddedItems) {
        sessionStorage.setItem('quizAdded', 'true');
        window.location.reload();
        return;
      }
  
      // otherwise, if the cart toggle has items, open the cart drawer
      const cartToggle = document.querySelector('[data-cart-drawer-toggle]');
      if (cartToggle && cartToggle.classList.contains('cart__toggle--has-items')) {
        cartToggle.click();
      }
    }
  
    function showIntro() {
      content.innerHTML = `
        <div class="quiz-header">
          <h2>stem skincare</h2>
          <button class="quiz-close">×</button>
        </div>
        <p>A dëshironi të dini se për çfarë produkte keni nevojë?</p>
        <div class="quiz-answers">
          <button id="intro-yes" class="quiz-btn">Vazhdo</button>
          <button id="intro-no"  class="quiz-btn">Largo</button>
        </div>
      `;
      content.querySelector('.quiz-close').onclick = closeQuiz;
      content.querySelector('#intro-no').onclick = closeQuiz;
      content.querySelector('#intro-yes').onclick = () => {
        step = 0;
        userAnswers = [];
        showStep();
      };
    }
  
    function showStep() {
      const { question, answers: baseAnswers } = questions[step];
      let answers = baseAnswers;

      // If the user selected very sensitive or slightly sensitive,
      // we add an extra option in the following multi-choice question.
      if (step === 2) {
        const sensAns = userAnswers?.[1]?.answer;
        const isSensitive = sensAns === "Po, është shumë e ndjeshme" || sensAns === "Po, jam pak e ndjeshme";
        if (isSensitive && !answers.includes(rosaceaOption)) {
          answers = [...answers, rosaceaOption];
        }
      }
      // build the note depending on single vs. multi choice
      const noteText = step === 2
        ? 'Mund të zgjedhni më shumë se një përgjigje, pastaj kliko "Vazhdo"'
        : 'Zgjedh një përgjigje';
  
      content.innerHTML = `
        <div class="quiz-header">
          <h2>${step+1}/${questions.length}</h2>
          <button class="quiz-close">×</button>
        </div>
        <p>${question}</p>
        <p class="quiz-note">${noteText}</p>
        <div class="quiz-answers">
          ${answers.map(a => `<button class="quiz-btn">${a}</button>`).join('')}
          ${step > 0 ? '<button class="quiz-back">KTHEHU</button>' : ''}
          ${step === 2 ? '<button class="quiz-next">VAZHDO</button>' : ''}
        </div>
      `;
  
      if (step > 0) {
        content.querySelector('.quiz-back').onclick = () => {
          step--;
          showStep();
        };
      }
      content.querySelector('.quiz-close').onclick = closeQuiz;
  
      if (step === 2) {
        // multi-choice logic with disabling Vazhdo until selection
        const nextBtn = content.querySelector('.quiz-next');
        nextBtn.disabled = true;
  
        content.querySelectorAll('.quiz-answers .quiz-btn').forEach(btn => {
          btn.onclick = () => {
            btn.classList.toggle('selected');
            const anySelected = content.querySelectorAll('.quiz-answers .quiz-btn.selected').length > 0;
            nextBtn.disabled = !anySelected;
          };
        });
  
        nextBtn.onclick = () => {
          const selectedBtns = Array.from(content.querySelectorAll('.quiz-answers .quiz-btn.selected'));
          const selectedAnswers = selectedBtns.map(b => b.textContent.trim());
          userAnswers[step] = { question, answer: selectedAnswers };
          step++;
          showStep();
        };
      } else {
        // single-choice logic
        const prevAnswer = (userAnswers[step] && userAnswers[step].answer) || '';
        content.querySelectorAll('.quiz-btn').forEach(btn => {
          btn.classList.remove('selected');
          if (btn.textContent.trim() === prevAnswer.trim()) {
            btn.classList.add('selected');
          }
          btn.onclick = () => {
            userAnswers[step] = { question, answer: btn.textContent.trim() };
            if (step < questions.length - 1) {
              step++;
              showStep();
            } else {
              submitQuiz();
            }
          };
        });
      }
    }
  
    function showLoading() {
      content.innerHTML = `
        <div class="quiz-header">
          <button class="quiz-close">×</button>
        </div>
        <div class="quiz-loading">
          <h4>Ta kalkulojmë se cilat produkte preferohen më shumë për ty…</h4>
          <p style="margin-top:16px; font-size:12px; color:#555;">
            *P.S. Produktet si Pure Collagen, Salicylic Acid dhe Dual Renewal nuk rekomandohen gjatë shtatzënisë.
          </p>
        </div>
      `;
      content.querySelector('.quiz-close').onclick = closeQuiz;
    }
  
    function shuffle(arr) {
      return arr.sort(() => Math.random() - 0.5);
    }
  
    function showRecommendations() {
      localStorage.setItem('quizCompleted', 'true');
  
      const skinKey = skinTypeMap[userAnswers[0].answer];
      const sensAns = userAnswers[1].answer;
      const pregAns = userAnswers[4].answer;
      let serumPool = [...rawSerumMap[skinKey]];
      let includeCollagen = true;
  
      // 1) filter by sensitivity
      if (sensAns === "Po, është shumë e ndjeshme") {
        serumPool = serumPool.filter(
          t => !["Dual Renewal", "Vitamin C"].includes(t)
        );
      } else if (sensAns === "Po, jam pak e ndjeshme") {
        serumPool = serumPool.filter(t => t !== "Dual Renewal");
      }
  
      // 2) filter by pregnancy/breastfeeding
      if (pregAns === "Po, jam shtatzënë") {
        includeCollagen = false;
        serumPool = serumPool.filter(
          t => !["Dual Renewal", "Salicylic Acid"].includes(t)
        );
      }
      if (pregAns === "Po, jam duke ushqyer me gji") {
        includeCollagen = false;
        serumPool = serumPool.filter(t => t !== "Dual Renewal");
      }
  
      // pick 3 random serums
      const pickedSerums = shuffle(serumPool).slice(0, 3);
      let finalTitles = [...pickedSerums];
      if (includeCollagen) finalTitles.push(collagenTitle);
  
      const recs = finalTitles
        .map(title => {
          const prod = window.QUIZ_CATALOG.find(p =>
            p.title.toLowerCase().includes(title.toLowerCase())
          );
          return prod || null;
        })
        .filter(p => p);
  
      // ——— Cream recommendations based on skin type ———
      // Required rules:
      // - Normal or Dry: recommend Glow and Repair
      // - Combination: recommend Glow and Repair + Triple Hydration
      // - Oily: recommend Triple Hydration
      const glowAndRepair = window.QUIZ_CATALOG.find((p) => {
        const t = (p.title || "").toLowerCase();
        return t.includes("glow") && t.includes("repair");
      });
      const tripleHydration = window.QUIZ_CATALOG.find((p) => {
        const t = (p.title || "").toLowerCase();
        return t.includes("triple") && t.includes("hydration");
      });

      const skinAnswer = userAnswers[0]?.answer;
      const hasProd = (prod) => !!prod && recs.some((r) => r && r.id === prod.id);

      if (skinAnswer === "Normale" || skinAnswer === "E thatë") {
        if (glowAndRepair && !hasProd(glowAndRepair)) recs.unshift(glowAndRepair);
      } else if (skinAnswer === "E kombinuar") {
        if (glowAndRepair && !hasProd(glowAndRepair)) recs.unshift(glowAndRepair);
        if (tripleHydration && !hasProd(tripleHydration)) recs.unshift(tripleHydration);
      } else if (skinAnswer === "E yndyrshme") {
        if (tripleHydration && !hasProd(tripleHydration)) recs.unshift(tripleHydration);
      }

      // ——— Extra conditional recommendations ———
      // a) If hyperpigmentation was selected → sun visor
      if (Array.isArray(userAnswers[2].answer) && userAnswers[2].answer.some((a) => a.includes("Hiperpigmentim"))) {
        const sunVisor = window.QUIZ_CATALOG.find(p =>
          p.title.toLowerCase().includes("sun visor")
        );
        if (sunVisor) recs.push(sunVisor);
      }

      // d) If rosacea was selected → Azecalm serum
      if (
        Array.isArray(userAnswers[2].answer) &&
        userAnswers[2].answer.some((a) => a.toLowerCase().includes("rosacea"))
      ) {
        const azecalm = window.QUIZ_CATALOG.find((p) => {
          const t = (p.title || "").toLowerCase();
          return t.includes("azecalm");
        });
        if (azecalm && !hasProd(azecalm)) recs.unshift(azecalm);
      }
  
      // b) If skin is Dry or Normal → kompresa silikoni për pjesën nën sy
      if (["E thatë", "Normale"].includes(userAnswers[0].answer)) {
        const siliconeCompress = window.QUIZ_CATALOG.find(p =>
          p.title.toLowerCase().includes("kompresa silikoni")
        );
        if (siliconeCompress) recs.push(siliconeCompress);
      }
  
      // c) If any hair/nail issue → brushë silikoni për skalp
      if (!userAnswers[3].answer.startsWith("Nuk kam")) {
        const scalpBrush = window.QUIZ_CATALOG.find(p =>
          p.title.toLowerCase().includes("brushe silikoni")
        );
        if (scalpBrush) recs.push(scalpBrush);
      }

      // e) If "very sensitive" + "rosacea" -> keep only Azecalm + Pure Collagen
      // (and implicitly remove things like Salicylic Acid 2%)
      const rosaceaSelected =
        Array.isArray(userAnswers[2]?.answer) &&
        userAnswers[2].answer.some((a) => (a || "").toLowerCase().includes("rosacea"));

      const verySensitive = sensAns === "Po, është shumë e ndjeshme";
      if (verySensitive && rosaceaSelected) {
        const azecalmOnly = window.QUIZ_CATALOG.find((p) => {
          const t = (p.title || "").toLowerCase();
          return t.includes("azecalm");
        });
        const collagenOnly = window.QUIZ_CATALOG.find((p) => {
          const t = (p.title || "").toLowerCase();
          return t.includes("pure collagen");
        });

        recs.splice(0, recs.length);
        if (azecalmOnly) recs.push(azecalmOnly);
        if (collagenOnly) recs.push(collagenOnly);
      }
  
      content.innerHTML = `
        <div class="quiz-header">
          <h2 class="recs-title">Rekomandimet tuaja</h2>
          <button class="quiz-close">×</button>
        </div>
        <div class="quiz-recs">
          ${recs.map(p => `
            <div class="rec">
              ${p.image ? `<img
                src="${p.image}"
                srcset="${p.image} 1x, ${p.image2x} 2x"
                sizes="160px"
                alt="${p.title}"
                style="width:160px; height:auto; object-fit:contain; object-position:center; margin:0 auto 8px;"
              >` : ''}
              <h6 style="
                font-size:16px;
                line-height:1.3;
                margin:6px auto 8px;
                width:160px;
                overflow-wrap:break-word;
                text-align:center;
              ">
                ${p.title}
              </h6>
              <p class="price" style="font-size:16px; line-height:1.3; margin-bottom:14px;">
                ${p.price}
              </p>
              <button class="add-to-cart" data-variant-id="${p.variant_id}" data-url="${p.url}">
                Shto në shportë
              </button>
            </div>
          `).join('')}
        </div>
      `;
      content.querySelector('.quiz-header .quiz-close').onclick = closeQuiz;
  
      // add-to-cart handler with bounce feedback
      content.querySelectorAll('.add-to-cart').forEach(btn => {
        btn.addEventListener('click', async () => {
          // bounce animation feedback
          btn.classList.add('clicked');
          setTimeout(() => btn.classList.remove('clicked'), 300);
  
          const variantId = btn.dataset.variantId;
          try {
            // Add item to cart
            const addRes = await fetch('/cart/add.js', {
              method:      'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Accept':       'application/json'
              },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
            });
            if (!addRes.ok) throw new Error(`Add failed (${addRes.status})`);
  
            // Update button state
            btn.textContent = 'U shtua';
            btn.disabled = true;
  
            // mark that we added something
            quizAddedItems = true;
  
            // Fetch updated cart items section
            const sectionRes = await fetch('https://www.stemskincare.com/cart?section_id=api-cart-items', {
              credentials: 'same-origin'
            });
            if (sectionRes.ok) {
              const html = await sectionRes.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newItems = doc.querySelector('#CartDrawer, .js-cart-drawer');
              const drawer = document.querySelector('#CartDrawer, .js-cart-drawer');
              if (drawer && newItems) {
                drawer.innerHTML = newItems.innerHTML;
              }
            }
          } catch (err) {
            console.error('Add-to-cart error:', err);
          }
        });
      });
    }
  
    async function submitQuiz() {
      showLoading();
      try {
        await fetch("https://stemskincare-server.vercel.app/api/quiz", {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ answers: userAnswers, catalog: window.QUIZ_CATALOG })
        });
        showRecommendations();
      } catch (e) {
        console.error(e);
        closeQuiz();
      }
    }
  
    window.openQuiz = () => {
      modal.style.display = 'flex';
      showIntro();
    };
  
    // after a refresh, open cart if quiz added items
    window.addEventListener('load', () => {
      if (sessionStorage.getItem('quizAdded') === 'true') {
        const cartToggle = document.querySelector('[data-cart-drawer-toggle]');
        if (cartToggle) {
          cartToggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        }
        sessionStorage.removeItem('quizAdded');
      }
    });
  
    document.addEventListener('DOMContentLoaded', () => {
      if (!sessionStorage.getItem('quizSeen')) {
        setTimeout(() => {
          openQuiz();
          sessionStorage.setItem('quizSeen', 'true');
        }, 5000);
      }
    });
  })();
  